import { DaysType } from 'app/constants/configuration/daysType'

export const getDaysTypeName = (
  daysType: DaysType,
  translate: (string) => string,
): string => {
  const text: string = DaysType[daysType]
  return translate(`daysType.${text}`)
}
